
import createModelBundle from './modelBundle'


const config = {
  bundleName: 'DiscountTag',
  camelCaseBundleName: 'discountTag',
  verboseName: 'e-tag',
  url: 'discountTags',
  allowDelete: false,
}

const baseBundle = createModelBundle(config)

export default {
  ...baseBundle,
}
